import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./Tile.scss";

// ! deprecated, use direct Tile children instead
const TileContent = forwardRef((props, ref) => {
  const { children, hover, customClass, ...otherProps } = props;
  const classes = classNames({
    [styles.hover]: hover,
    [customClass]: customClass,
  });
  return (
    <div className={classes} ref={ref} {...otherProps}>
      {children}
    </div>
  );
});

TileContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  hover: PropTypes.bool,
  customClass: PropTypes.string,
};

TileContent.defaultProps = {
  hover: false,
  customClass: null,
};

TileContent.displayName = "Tile.Content";

export default TileContent;
